var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { config } from 'lib-shared-backend-config';
import { ajaxSend } from 'api/api';
import draftEmailHelper from '../helper/DraftEmailHelper';
export const base = '/v1/conversations';
export function getDrafts() {
    try {
        const emailDrafts = draftEmailHelper.getDrafts();
        return Promise.resolve(emailDrafts);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
export function removeDraft({ timestamp, }) {
    try {
        const emailDrafts = draftEmailHelper.getDrafts() || { drafts: [] };
        const filteredEmailDrafts = emailDrafts.drafts.filter((draft) => draft.timestamp !== timestamp);
        const payload = {
            drafts: filteredEmailDrafts,
        };
        draftEmailHelper.setDrafts(payload);
        return Promise.resolve(payload);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
export function saveDraft(payload) {
    try {
        const { fromEmails, toUser, subject, message, internalNote, attachments, tags, cc, bcc, queue, offer, satisfactionLanguage, cancelledSatisfaction, parentConversation, linkConversationType, messageContentType, } = payload;
        const email = {
            timestamp: new Date().getTime(),
            fromEmails,
            toUser,
            cc,
            bcc,
            subject,
            message,
            internalNote,
            attachments,
            tags,
            queue,
            offer,
            satisfactionLanguage,
            cancelledSatisfaction,
            linkConversationType,
            messageContentType,
            parentConversation,
        };
        const emailDrafts = draftEmailHelper.getDrafts() || {
            drafts: [],
        };
        // Add email to drafts array.
        draftEmailHelper.setDrafts({
            drafts: [...emailDrafts.drafts, email],
        });
        return Promise.resolve(draftEmailHelper.getDrafts());
    }
    catch (e) {
        return Promise.reject(e);
    }
}
export function sendEmail({ from_email, to_email, subject, body, attachments_v2, tags, cc, bcc, content_type, language, internalNote, offer, queueId, parentConversation, linkType, }) {
    const data = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ from_email,
        to_email,
        subject,
        body,
        content_type }, ((attachments_v2 === null || attachments_v2 === void 0 ? void 0 : attachments_v2.length) ? { attachments_v2 } : {})), ((cc === null || cc === void 0 ? void 0 : cc.length) ? { cc_emails: cc } : {})), ((bcc === null || bcc === void 0 ? void 0 : bcc.length) ? { bcc_emails: bcc } : {})), ((tags === null || tags === void 0 ? void 0 : tags.length) ? { tags: tags.map((tag) => tag.id) } : {})), (language ? { language } : {})), ((internalNote === null || internalNote === void 0 ? void 0 : internalNote.length) ? { internal_note: internalNote } : {})), (offer ? { offer } : {})), (queueId ? { queue_id: queueId } : {})), (parentConversation
        ? {
            link: Object.assign({ parent_csid: parentConversation }, (linkType ? { link_type: linkType } : {})),
        }
        : {}));
    return ajaxSend({
        path: `${base}/email`,
        method: 'POST',
        data,
    });
}
export function upload(payload) {
    if (payload === undefined || payload === null) {
        console.error('upload - No valid payload given.');
        return Promise.reject();
    }
    const { file } = payload;
    if (file === undefined) {
        console.error('upload file - No valid file in payload given.');
        return Promise.reject();
    }
    const data = new FormData();
    data.append('file', file);
    const request = {
        path: `/private/attachment`,
        method: 'POST',
        files: true,
        contentType: 'multipart/form-data',
        wrapAsJSON: false,
        data: data,
    };
    return ajaxSend(request).then((response) => {
        if (response.data !== undefined &&
            response.data.relative_uri !== undefined &&
            typeof response.data.relative_uri === 'string') {
            response.data.absolute_uri =
                config.url.files + response.data.relative_uri;
        }
        return response;
    });
}
export function findUser(payload) {
    const search = payload;
    //search?scope=user&query= &facetFilters=has_email:true
    return ajaxSend({
        path: `/v2/search?scope=user&query=${encodeURIComponent(search)}&pageSize=10`,
    });
}
export function findContact(arg) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield ajaxSend({
            path: `/v3/search/advanced/contacts`,
            method: 'POST',
            data: arg.params,
        });
        return {
            data: {
                results: response.data,
            },
            meta: {},
        };
    });
}
export function getAllFrom() {
    return ajaxSend({
        path: '/v1/integrations/email',
    });
}
export function getPresignedUrl(file) {
    return ajaxSend({
        path: '/v1/uploads/presigned_url/user_avatar',
        method: 'POST',
        data: {
            pretty_name: file.name,
            content_type: file.type,
        },
    });
}
export function addAttachments(presigned, file) {
    return ajaxSend({
        method: 'PUT',
        headers: {
            authorization: null,
            contentType: file.type,
        },
        data: file,
        path: presigned.upload_url,
    });
}
